import { createSelector } from '@reduxjs/toolkit';

import { getIsMobile } from 'src/store/view/selectors';
import { isMapViewSelector } from '../store/map/selectors';

const getViewParams = (state) => state.get('view');

export const isFiltersHidden = (state) =>
  getViewParams(state).get('hideSidebar');

// export const getMobilePlatform = state => getViewParams(state).get('platform');
export const getIsWhitelabel = (state) =>
  !!getViewParams(state).get('isWhitelabel');
export const getIsSubscribeShown = (state) =>
  getViewParams(state).get('showSubscribePopup');

export const viewStateSelector = createSelector(
  [getIsMobile, isMapViewSelector],
  (isMobile, isMapExpanded) => {
    if (isMobile) return 'isMobile';
    if (isMapExpanded) return 'isMapView';

    return 'default';
  },
);
/** Пресет приоритетов фильтров */
export const filtersPrioritySelector = (state) =>
  getViewParams(state).get('filtersPriority');
